import { Button } from '@cian/ui-kit';
import * as React from 'react';

interface IShareButtonProps {
  onClick(): void;
  text: string;
}

export const ShareButton: React.FC<IShareButtonProps> = ({ onClick, text }) => {
  return (
    <Button theme="fill_primary" size="L" onClick={onClick}>
      {text}
    </Button>
  );
};

ShareButton.displayName = 'ShareButton';
